// 目前品类和电话都是弹框形式暂时不用对应的fieldKey

export const baseFieldsMap = {
  'shopName': {
    fieldKey: 'shopName',
    label: '门店名称',
    msg: '请输入门店名称',
  },
  'branchName': {
    fieldKey: 'branchName',
    label: '分店名称'
  },
  'phoneList': {
    fieldKey: 'phoneList',
    label: '门店电话'
  },
  'address': {
    fieldKey: 'address',
    label: '门店地址',
    msg: '请输入地址'
  },
  'openStatus': {
    fieldKey: 'openStatus',
    label: '营业状态',
  },
  'map': {
    fieldKey: 'location',
    label: '地图'
  },
  'shopBackNames0': {
    fieldKey: 'backCateId',
    label: '主品类后台',
    msg: '请选择门店品类'
  },
  'shopBackNames1': {
    fieldKey: 'category1',
    label: '次品类后台'
  },
  'shopBackNames2': {
    fieldKey: 'category2',
    label: '次品类后台2'
  },
  'shopBackNames3': {
    fieldKey: 'category3',
    label: '次品类后台3'
  },
  'shopBackNames4': {
    fieldKey: 'category4',
    label: '次品类后台4'
  },
  'businessHours': {
    fieldKey: 'bizTime',
    label: '营业时间'
  },
  'mtRegionId': {
    fieldKey: 'mtRegionIds',
    label: '美团商圈'
  },
  'dpRegionId': {
    fieldKey: 'dpRegionIds',
    label: '商圈'
  },
  'picInfos': {
    fieldKey: 'picInfos',
    label: '图片'
  },
  'serviceArea': {
    fieldKey: 'serviceArea',
    label: '服务范围'
  },
}
